// src/components/Overview.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchProject } from '../hooks/projectService';
import { setProject, setStatus, setError, selectProject, selectStatus, selectError } from "../features/project/projectSlice";
import { useSingleProject } from '../hooks/useSingleProject';


function Overview() {


  // import { selectAllProjects, selectProjectsStatus, selectProjectsError } from '../features/projectsSlice';

// const OrderPage = ({ userId, role }) => {
  const { projectId } = useParams();
  const { isLoading, isError, error, data } = useSingleProject(projectId);
  console.log("data to check", data);
  // const projects = useSelector(selectAllProjects);
  // const status = useSelector(selectProjectsStatus);
  // const reduxError = useSelector(selectProjectsError);




 
  const dispatch = useDispatch();
  // const project = useSelector(selectProject);
  // const status = useSelector(selectStatus);
  // const error = useSelector(selectError);

  const formatIndianPrice = (price) => {
 return new Intl.NumberFormat('en-IN').format(price);
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN');
};

  // const { isLoading, isError, data } = useQuery({
  //   queryKey: ['project', projectId],
  //   queryFn: () => fetchProject(projectId),
  //   onSuccess: (data) => {
  //     console.log("Query succeeded, dispatching setProject", data);
  //     dispatch(setProject(data));
  //     dispatch(setStatus('succeeded'));
  //   },
  //   onError: (error) => {
  //     console.error("Query failed, dispatching setError", error);
  //     dispatch(setError(error.message));
  //     dispatch(setStatus('failed'));
  //   },
  // });

  useEffect(() => {
    if (isLoading) {
      console.log("Dispatching loading status");
      dispatch(setStatus('loading'));
    }
  }, [isLoading, dispatch]);

  useEffect(() => {
    // console.log("Component updated with new state:", { project, status, error });
  }, [data, isLoading, error]);

  // console.log("Component state:", { project, status, error, isLoading, isError });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container-fluid p-3" style={{backgroundColor:'#F9FAFB', borderRadius:10, color:'#000', overflowY:'auto', maxHeight:'68vh'}}>
      <h3>Summary</h3>
      {data ? (
        <div>
          {/* <p><strong>Project ID:</strong> {projectId}</p> */}
          <p><strong>Name:</strong> {data.name}</p>
          <p><strong>Client Name:</strong> {data.clientName}</p>
          <p><strong>Mobile Number:</strong> {data.mobNumber}</p>
          <p><strong>Property Name:</strong> {data.propertyName}</p>
          <p><strong>Address:</strong> {data.address}</p>
          <p><strong>City:</strong> {data.city}</p>
          <p><strong>Sales BOQ:</strong> ₹{formatIndianPrice(data.projectValue)}</p>
          <p><strong>Discount:</strong> {data.discount}%</p>
          <p><strong>Booking Amount:</strong> ₹{formatIndianPrice(data.bookingAmount)}</p>
          <p><strong>TXN ID:</strong> {data.txnId}</p>
          <p><strong>Meeting Date:</strong> {data.meetingDate ? formatDate(data.meetingDate)  : formatDate(data.dateOfEnquiry)}</p>
          <p><strong>Date of Closure:</strong> {formatDate(data.closureDate)}</p>
          <p><strong>Source:</strong> {data.source}</p>

         
        </div>
      ) : (
        <p>No project found.</p>
      )}
    </div>
  );
}

export default Overview;